export const sizeScale = 0.01;
export const baseWidthDp = 1920 * sizeScale;
export const baseHeightDp = 1080 * sizeScale;
export const textWidthDp = 880 * sizeScale;
export const baseWidthMb = 750 * sizeScale;
export const baseHeightMb = 1300 * sizeScale;
export const textWidthPt = 560 * sizeScale;
export const textWidthMb = 720 * sizeScale;
export const textWidthMbLp = 880 * sizeScale;
export const ptFactor = 1.6;

const refSize = 10;

export const SIZES_COMMON = {
    sensitivity: 0.75,
    camDistance: refSize * 2,
    camFar: refSize * 6,
    keyboardStep: 30,
    bgSceneAspectRatio: 1.4 // 4
};

export const UNIT = {
    refSize,
    yScrollStepSize: refSize * 2 * 2.5,
    questionR: refSize * 0.85 * 1.34,
    questionY: -refSize * 0.35 * 1.34,
    plateH: refSize * 0.16 * 1.34,
    plateR: refSize * 0.6 * 1.34,
    plateY: -refSize * 0.35 * 1.34,
    scoreH: 25 * sizeScale,
    scoreR: 70 * sizeScale
};

export const REF_SIZE = {
    w: baseWidthDp,
    h: baseHeightDp,
    axisDistance: refSize * 0.8,
    questionYCorrection: 0,
    shiftYTextBlockNumLines: 1.4,
    questionScale: 1,
    button: {
        width: 422 * sizeScale,
        height: 89 * sizeScale
    },
    arrowButton: {
        radius: 89 * 0.75 * sizeScale,
        marginSide: 50 * sizeScale
    },
    shareButton: {
        radius: 89 * 0.251 * sizeScale,
        marginSide: 89 * 0.625 * sizeScale,
        marginTop: 89 * 0.625 * sizeScale
    },
    buttonMarginTop: 81 * sizeScale
    /* question: {
        back: {
            width: 1020,
            height: 560
        },
        titleHeight: 182,
        option: {
            width: 938,
            height: 80
        }
    } */
};

export const REF_SIZE_PT = {
    w: baseHeightMb,
    h: baseWidthMb,
    axisDistance: refSize * 1.2,
    questionYCorrection: -refSize * 0.2,
    shiftYTextBlockNumLines: 1.4,
    questionScale: 1,
    button: {
        width: 422 * sizeScale,
        height: 89 * sizeScale
    },
    arrowButton: {
        radius: 89 * 0.75 * sizeScale,
        marginSide: 50 * sizeScale
    },
    shareButton: {
        radius: 89 * 0.251 * sizeScale,
        marginSide: 89 * 0.625 * sizeScale,
        marginTop: 89 * 0.625 * sizeScale
    },
    buttonMarginTop: 140 * sizeScale
};

export const REF_SIZE_MB_PT = {
    w: baseHeightMb,
    h: baseWidthMb,
    axisDistance: refSize * 1.25,
    axisYCorrection: refSize * 0.4,
    questionYCorrection: -refSize * 0.6,
    shiftYTextBlockNumLines: 1.4,
    questionScale: 1.04,
    button: {
        width: 422 * 1.4 * sizeScale,
        height: 89 * 1.4 * sizeScale
    },
    arrowButton: {
        radius: 89 * 1.4 * 0.75 * sizeScale,
        marginSide: 70 * sizeScale,
        marginTop: 15 * sizeScale
    },
    shareButton: {
        radius: 89 * 1.4 * 0.4 * sizeScale,
        marginSide: 89 * 1.4 * 0.925 * sizeScale,
        marginTop: 89 * 1.4 * 0.925 * sizeScale
    },
    buttonMarginTop: 10 * sizeScale
};

export const REF_SIZE_MB_LP = {
    w: baseWidthDp,
    h: baseHeightDp,
    axisDistance: refSize * 0.8,
    questionYCorrection: refSize * 0.1,
    shiftYTextBlockNumLines: 0,
    questionScale: 1.2,
    button: {
        width: 422 * 1.5 * sizeScale,
        height: 89 * 1.5 * sizeScale
    },
    arrowButton: {
        radius: 89 * 1.5 * 0.75 * sizeScale,
        marginSide: 15 * sizeScale
    },
    shareButton: {
        radius: 89 * 1.5 * 0.251 * sizeScale,
        marginSide: 89 * 1.5 * 0.625 * sizeScale,
        marginTop: 89 * 1.5 * 0.625 * sizeScale
    },
    buttonMarginTop: 0
};

export const SIZE_OPTIONS = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait',
    MOBILE_LANDSCAPE: 'mobilelandscape',
    MOBILE_PORTRAIT: 'mobileportrait'
};

export const SIZE_REFS_MAP = {
    landscape: REF_SIZE,
    portrait: REF_SIZE_PT,
    mobilelandscape: REF_SIZE_MB_LP,
    mobileportrait: REF_SIZE_MB_PT
};
